import { z } from "zod";
import * as FlatModels from '../../internal';

export const StatusSeverity = z.enum([
  'pending',
  'processing',
  'finished',
  'error'
]);
export type StatusSeverity = z.infer<typeof StatusSeverity>;

export const StatusSeverityClassSchema = z.record(StatusSeverity, FlatModels.TagDesignModels.Severity);

export const StatusSeverityClass: z.infer<typeof StatusSeverityClassSchema> = {
  [StatusSeverity.enum.pending]: FlatModels.TagDesignModels.Severity.enum.info,
  [StatusSeverity.enum.processing]: FlatModels.TagDesignModels.Severity.enum.warning,
  [StatusSeverity.enum.finished]: FlatModels.TagDesignModels.Severity.enum.success,
  [StatusSeverity.enum.error]: FlatModels.TagDesignModels.Severity.enum.danger,
}

export const ImportStatsEntrySchema = z.object({
  id: z.string(),
  key: z.string(),
  name: z.string(),
  size: z.number(),
  profile: z.string().default('unknown'),
  slideId: z.string().nullable(),
  lastModified: z.string(),
  media: z.array(z.object({ id: z.string(), depth: z.number() })).optional(),
  status: z.string(),
  logs: z.array(z.object({ ts: z.string(), m: z.string() })).optional()
});

export type ImportStatsEntry = z.infer<typeof ImportStatsEntrySchema>;

export const ImportStatsSchema = z.array(
  ImportStatsEntrySchema
);

export type ImportStats = z.infer<typeof ImportStatsSchema>;
